import axios from 'axios';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // gunakan variable dari .env
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false, // ubah ke true kalau backend pakai cookie-based auth
});

// === Interceptor untuk tambahkan token Bearer otomatis ===
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // selalu ambil fresh
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

export default axiosClient;
